import CallSummaryCard from "./CallSummaryCard";

export default function CallSummaryCards({ cards = [] }) {
  return (
    <div className="ebhc-call-card-grid">
      {cards.slice(0, 2).map((card, index) => (
        <CallSummaryCard
          key={card.key || index}
          icon={card.icon}
          label={card.label}
          value={card.value}
          duration={card.sub || card.duration}
          variant={card.variant || (index === 0 ? "inbound" : "outbound")}
          animate={card.animate}
        />
      ))}
    </div>
  );
}